import { ProcessRoleCoreBase } from "./process-role.core.base"


export class ProcessRoleCore extends ProcessRoleCoreBase {

}